import type { ComponentProps } from 'react';

import Plus from '@/public/assets/svg/Icon/Plus.svg';

export const IconPlus = ({ ...props }: ComponentProps<'svg'>) => {
  return <Plus {...props} />;
};
